import React, { useState, useCallback, } from 'react';
import FormTextArea from '../../../controls/FormTextArea';
import TextAreaValueView from '../../../controls/ValueViews/TextAreaValueView';
import EntityField from '../internal/EntityField';
import useHelpNote from '../../../utils/Translations/useHelpNote';
const DEFAULT_MAX_LENGTH = 254;
const TextAreaField = ({ noLabel = false, label, placeholder, noViewLabel = false, minLength = 0, maxLength = DEFAULT_MAX_LENGTH, isEditable = false, name, className, hasSubmitOnEnter, onMouseUp, onBlur, handleSelect, viewClassName, rows, isReadOnly = false, required = false, validate, isScroll = true, clobsPreviewData, hasRenderedPreview = false, dataCy, tooltipTitle, ...rest }) => {
    const getHelpNoteTooltipTitle = useHelpNote();
    const [stateError, setError] = useState('');
    const resolvedTooltipTitle = tooltipTitle || getHelpNoteTooltipTitle(label || placeholder || '');
    const _validate = useCallback(value => {
        if (validate && validate(value)) {
            return validate(value);
        }
        if (!value && required) {
            return 'Required';
        }
        if (maxLength && value && value.length > maxLength) {
            const error = `Max length is ${maxLength}`;
            if (value.length === maxLength) {
                setError(error);
                return '';
            }
            return error;
        }
        if (minLength && value && value.length < minLength) {
            const error = `Min length is ${minLength}`;
            if (value.length < minLength) {
                setError(error);
                return '';
            }
            return error;
        }
        setError('');
        return '';
    }, [required, validate, maxLength, minLength]);
    return (<EntityField name={name} {...rest} required={required} validate={_validate}>
      {(editable, { meta, ...field }, { required, disabled }) => !isReadOnly && (editable || isEditable) ? (<FormTextArea animateTitle={!noLabel} className={className} dataCy={dataCy} disabled={disabled} handleSelect={handleSelect} hasSubmitOnEnter={hasSubmitOnEnter} label={label} maxLength={maxLength} meta={{
        ...meta,
        error: meta.error || stateError,
    }} minLength={minLength} placeholder={placeholder || label} required={required} rows={rows} tooltipTitle={resolvedTooltipTitle} onBlur={onBlur} onMouseUp={onMouseUp} {...field}/>) : (<TextAreaValueView className={viewClassName} clobsPreviewData={clobsPreviewData} hasRenderedPreview={hasRenderedPreview} isScroll={isScroll} label={label} noLabel={noViewLabel} rows={rows} value={field.input.value || ''}/>)}
    </EntityField>);
};
export default TextAreaField;
